import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import codeRequestStoreModule from './store.code.request'
import encStoreModule from "@/store/store.enc";

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths: ['codeRequestStore', 'encStoreModule'],
  })],
  modules: {
    codeRequestStore: codeRequestStoreModule,
    encStoreModule: encStoreModule,
  }
})
